import axios from "axios";
import { useContext, useEffect, useState } from "react";

import styled from "styled-components";
import PriceCard from "../components/PriceCard";
import { UserContext, UserCountryContext } from "../context/AuthContext";
import Head from "next/head";
import { useRouter } from "next/router";
import Layout from "@/components/layout";
import Features from "@/components/Features";
import InputRange from "@/components/InputRange";

export default function Pricing() {
  const user = useContext(UserContext);
  let country = useContext(UserCountryContext);
  const [isActive, setIsActive] = useState(1);
  const [nigerianAmount, setNigerianAmount] = useState<number>(3000);
  const [foreignAmount, setForeignAmount] = useState<number>(21);
  const router = useRouter();

  const [rangeValue, setRangeValue] = useState<number>(50); // Initial value

  const handleRangeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(event.target.value, 10); // Parse the string to a number
    setRangeValue(newValue);
  };

  //trigger for changing prices in Nigeria
  useEffect(() => {
    if (rangeValue === 50) {
      setNigerianAmount(300000);
    } else if (rangeValue === 200) {
      setNigerianAmount(1000000);
    } else if (rangeValue === 350) {
      setNigerianAmount(2100000);
    } else if (rangeValue === 500) {
      setNigerianAmount(2700000);
    }
  }, [rangeValue]);

  //Trigger for changing prices in Dollars
  useEffect(() => {
    if (rangeValue === 50) {
      setForeignAmount(21);
    } else if (rangeValue === 200) {
      setForeignAmount(80);
    } else if (rangeValue === 350) {
      setForeignAmount(140);
    } else if (rangeValue === 500) {
      setForeignAmount(200);
    }
  }, [rangeValue]);

  country === "Nigeria" ? "₦" : "$";
  const monthlyPriceForCountry = (country: string | null, period: string) => {
    const monthlyPricePerPeriod: { [key: string]: number } = {
      Resume: country === "Nigeria" ? nigerianAmount : foreignAmount,
      CoverLetter: country === "Nigeria" ? nigerianAmount : foreignAmount,
      Email: country === "Nigeria" ? nigerianAmount : foreignAmount,
    };

    return monthlyPricePerPeriod[period as keyof typeof monthlyPricePerPeriod];
  };

  const Plan1 = [
    {
      type: "Free",
      price: 0,
      description: "",
      title: "Standard",
      info1: "5 Credits",
      planId: "",
      displayName: "credits",
    },
    {
      type: "Resume",
      price: monthlyPriceForCountry(country, "Resume") as number,

      detail: "",
      description: `Find missing keywords in your resume and land more interviews`,
      title: "Standard",
      info1: `${rangeValue} credits`,
      planId: process.env.NEXT_PUBLIC_PAYSTACK_PLAN_ID_ANNUALY,
      displayName: "credits",
    },
  ];

  const Plan2 = [
    {
      type: "Free",
      price: 0,
      description: "",
      title: "Standard",
      info1: "5 Credits",
      planId: "",
      displayName: "credits",
    },
    {
      type: "CoverLetter",

      price: monthlyPriceForCountry(country, "CoverLetter") as number,
      detail: "",
      description: `Get job winning cover letters for every job application in seconds and land your dream job`,
      title: "Standard",
      info1: `${rangeValue} credits`,
      planId: process.env.NEXT_PUBLIC_PAYSTACK_PLAN_ID_BINUALLY,
      displayName: "credits",
    },
  ];
  const Plan3 = [
    {
      type: "Free",
      price: 0,
      description: "",
      title: "Standard",
      info1: "60 Credits",
      planId: "",
      displayName: "emailcredits",
    },
    {
      type: "Email",

      price: monthlyPriceForCountry(country, "Email") as number,
      detail: "",
      description: `Find emails of employees in your dream company easily and get headed of the curve `,
      title: "Standard",
      info1: `${rangeValue} credits`,
      planId: process.env.NEXT_PUBLIC_PAYSTACK_PLAN_ID_QUATERLY,
      displayName: "emailcredits",
    },
  ];
  const Plan4 = [
    {
      type: "Free",
      price: 0,
      description: "",
      title: "Standard",
      info1: `40 credits`,
      planId: "",
      displayName: "submitcount",
    },
    {
      type: "Tracker",

      price: monthlyPriceForCountry(country, "Email") as number,
      detail: "",
      description: `No need for Spreadsheets or Notion ,Enjoy easy job tracking with daily metrics and charts `,
      title: "Standard",
      info1: `${rangeValue} credits`,
      planId: process.env.NEXT_PUBLIC_PAYSTACK_PLAN_ID_QUATERLY,
      displayName: "submitcount",
    },
  ];
  // useEffect(() => {
  // 	async function getSubscriptionInfo() {
  // 		const data = await fetch('/api/paystackwebhook');
  // 		const lemonData = await fetch('/api/lemonwebhooks');
  // 		const result = await data.json();
  // 	}

  // 	getSubscriptionInfo();
  // }, []);

  //track users' location information

  const buttonDetails = [
    { id: 1, text: "Resume" },
    { id: 2, text: "CoverLetter" },
    { id: 3, text: "Email" },
    { id: 4, text: "Tracker" },
  ];

  //add canonical tag
  const canonicalUrl = (
    `https://uiland.design` + (router.asPath === "/" ? "" : router.asPath)
  ).split("?")[0];
  return (
    <>
      <Head>
        <title>InstantApply Pricing</title>
        <meta
          name="title"
          property="og:title"
          content="Analyze your Resume and Autofill job applications easily"
        />

        <meta name="keywords" content="jobs,cv,resume " />
        <meta
          name="description"
          content="Analyze your Resume and Autofill job applications easily"
        />
        <link rel="icon" href="/favicon.ico" />

        <link rel="canonical" href={canonicalUrl} key="canonical" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />

        <meta property="og:url" content="https://instantapply.co" />
        <meta property="og:title" content="instantapply.co" />
        <meta
          name="description"
          property="og:description"
          content="Analyze your Resume and Autofill job applications easily"
        />
        <meta property="og:site_name" content="instantapply.co" />
        <meta
          name="image"
          property="og:image"
          content="https://yauoagpuebtzbgpptwsp.supabase.co/storage/v1/object/public/image/instantapply-image.png"
        />
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://instantapply.co" />
        <meta property="twitter:site" content="@uiland" />
        <meta
          property="twitter:title"
          content="Analyze your Resume and Autofill job applications easily"
        />
        <meta
          property="twitter:description"
          content="Analyze your Resume and Autofill job applications easily"
        />
        <meta
          property="twitter:image"
          content="https://yauoagpuebtzbgpptwsp.supabase.co/storage/v1/object/public/image/instantapply-image.png"
        />
        <meta name="next-head-count" content="23" />
      </Head>
      <Layout>
        <PricingWrapper>
          <section className="pricing-text">
            <h1 className="pricing-text-primary font-silka">
              Apply to Jobs easier and faster
            </h1>
            <p className="pricing-text-sec font-silka">
              Land your dream role with Instantapply
            </p>
          </section>
          <section className="price-tabs">
            {buttonDetails.map((details) => {
              return (
                <button
                  onClick={() => setIsActive(details.id)}
                  key={details.id}
                  className={`font-silka price-btn price-btn--${
                    isActive === details.id ? "active" : ""
                  }`}
                >
                  {details.text}
                </button>
              );
            })}
          </section>
          <section className="flex items-center justify-center">
            <h3 className="text-5xl mr-1 font-bold">{rangeValue}</h3>
            <p>credits</p>
          </section>
          <section>
            <InputRange
              handleRangeChange={handleRangeChange}
              rangeValue={rangeValue}
            />
          </section>
          <section className="price-cards">
            <section
              className={`font-silka price-cards-annual price-card-annual--${
                isActive === 1 ? "active" : ""
              }`}
            >
              {Plan1.map((items, id) => {
                return (
                  <PriceCard
                    key={id}
                    type={items.type}
                    price={items.price}
                    detail={items.detail}
                    description={items.description}
                    title={items.title}
                    info1={items.info1}
                    country={country}
                    displayName={items.displayName}
                  />
                );
              })}
            </section>
            <section
              className={`font-silka price-cards-annual price-card-annual--${
                isActive === 2 ? "active" : ""
              }`}
            >
              {Plan2.map((items, id) => {
                return (
                  <PriceCard
                    key={id}
                    type={items.type}
                    price={items.price}
                    detail={items.detail}
                    description={items.description}
                    title={items.title}
                    info1={items.info1}
                    country={country}
                    displayName={items.displayName}
                  />
                );
              })}
            </section>
            <section
              className={`font-silka price-cards-annual price-card-annual--${
                isActive === 3 ? "active" : ""
              }`}
            >
              {Plan3.map((items, id) => {
                return (
                  <PriceCard
                    key={id}
                    type={items.type}
                    price={items.price}
                    detail={items.detail}
                    description={items.description}
                    title={items.title}
                    info1={items.info1}
                    country={country}
                    displayName={items.displayName}
                  />
                );
              })}
            </section>
            <section
              className={`font-silka price-cards-annual price-card-annual--${
                isActive === 4 ? "active" : ""
              }`}
            >
              {Plan4.map((items, id) => {
                return (
                  <PriceCard
                    key={id}
                    type={items.type}
                    price={items.price}
                    detail={items.detail}
                    description={items.description}
                    title={items.title}
                    info1={items.info1}
                    country={country}
                    displayName={items.displayName}
                  />
                );
              })}
            </section>
          </section>
        </PricingWrapper>
      </Layout>
      <Features />
    </>
  );
}

const PricingWrapper = styled.div`
  width: 90%;
  margin: 7em auto 3em;

  .pricing-text-primary {
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    color: #000;
    margin: 0;
    @media (min-width: 760px) {
      font-size: 40px;
    }
  }

  .pricing-text-sec {
    font-size: 16px;
    font-weight: bold;
    color: var(--text-color-dark-secondary);
    line-height: 1.5;
    text-align: center;
    margin: 0.5em;
    @media (min-width: 760px) {
      font-size: 20px;
    }
  }

  .price-tabs {
    margin: 2em auto;
    border-radius: 0.5em;
    border: 1px solid #ddd;
    display: flex;
    flex-wrap: wrap;
    max-width: 530px;
    justify-content: space-between;
  }

  .price-btn {
    color: #666;
    border: none;
    padding: 0.9em 2.1em;
    font-weight: 500;
    margin: 0;
    font-size: 14px;
    background-color: inherit;
    border-radius: 0.5em;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .pricing-text--description {
    font-size: 18px;
    text-align: center;
    margin-bottom: 2em;
  }

  .price-btn--active {
    background-color: #0066f5;
    color: #fff;
  }

  .price-cards-annual {
    position: relative;
    display: none;
    width: 90%;

    @media (min-width: 760px) {
      max-width: 700px;
      left: 50%;
      transform: translateX(-50%);
    }
    @media (max-width: 500px) {
      margin: auto;
    }
  }
  .price-card-annual--active {
    display: block;
    @media (min-width: 760px) {
      display: flex;
    }
  }
`;
